/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::66d6f03b04b75fa4fa2d813866d50710>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Basketball".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Sport emoji category.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const BasketballIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "BasketballIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.951 1.499a8 8 0 0 1-.05 4.192 15.5 15.5 0 0 1 2.148 1.24 8 8 0 0 1 3.605-2.14 6.47 6.47 0 0 0-2.404-2.42 6.47 6.47 0 0 0-3.299-.872m6.291 4.689A6.5 6.5 0 0 0 11.25 7.85c1.017.862 1.9 1.84 2.639 2.903.69-1.47.781-3.091.353-4.565m-1.232 5.955a13.7 13.7 0 0 0-2.704-3.126 6.5 6.5 0 0 0-.754 5.295 6.5 6.5 0 0 0 3.458-2.17M8.05 14.5a7.98 7.98 0 0 1 1.06-6.396 14 14 0 0 0-1.755-1.013q-.103.206-.22.408a7.98 7.98 0 0 1-4.788 3.709 6.47 6.47 0 0 0 2.404 2.42 6.47 6.47 0 0 0 3.299.872M1.758 9.812a6.48 6.48 0 0 0 4.208-3.3 13.7 13.7 0 0 0-4.059-.78 6.5 6.5 0 0 0-.15 4.08m.914-5.535a15 15 0 0 1 3.833.834 6.5 6.5 0 0 0-.057-3.423 6.48 6.48 0 0 0-3.776 2.589M6.836.085A7.97 7.97 0 0 1 12 1.072a7.97 7.97 0 0 1 3.437 3.979 7.99 7.99 0 0 1-.909 7.574 8 8 0 0 1-5.364 3.29A7.97 7.97 0 0 1 4 14.928 7.97 7.97 0 0 1 .563 10.95 7.99 7.99 0 0 1 1.072 4 7.99 7.99 0 0 1 6.836.085" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
BasketballIcon.displayName = 'BasketballIcon';
var _default = exports.default = BasketballIcon;